export default "__VITE_ASSET__D1yi$Qqj__"